const plugin = {};

plugin.install = (Vue) => {
  // eslint-disable-next-line
  Vue.prototype.$checkAuth = (code, authList = window._FUNCTIONAUTH_) => {
    const codeStr = code.toString();
    const codeNum = parseInt(code, 10);
    if (!authList) {
      return true;
    }
    if (authList.indexOf(codeNum) > -1 || authList.indexOf(codeStr) > -1) {
      return true;
    }
    return false;
  };
};

export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/vue-auth-control/index.js